import { inject } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import { PrivaLocalizationService } from '@priva/localization';

import { readTextFromNDEFRecord } from 'app/features/nfc/utils';

import { NfcReadEvent } from '../models';

const readingTagErrorMessage = 'NFC_SCAN.ERROR.TITLE.CANNOT_READ_DATA_FROM_NFC_TAG_TRY_AGAIN';

const noTextRecognizedMessage = 'NFC_SCAN.ERROR.TITLE.NO_TEXT_RECOGNIZED_IN_SCANNED_TAG';

export class NfcReaderService {
    privaLocalizationService = inject(PrivaLocalizationService);

    readerMalfunction$ = new ReplaySubject<boolean>(1);
    private abortController: AbortController | undefined;

    readEvent$ = new Subject<NfcReadEvent>();
    private ndef: NDEFReader | undefined;

    startReading() {
        if (this.ndef) return;
        try {
            this.ndef = new NDEFReader();
            this.abortController = new AbortController();
            // noinspection SpellCheckingInspection
            this.ndef.onreading = (readEvent) => {
                {
                    const readText = readEvent?.message?.records?.length
                        ? readTextFromNDEFRecord(readEvent.message.records[0])
                        : undefined;
                    if (readText) {
                        this.readEvent$.next({ readText, error: '' });
                    } else {
                        this.readEvent$.next({
                            readText: '',
                            error: this.privaLocalizationService.instant(noTextRecognizedMessage),
                        });
                    }
                }
            };

            // noinspection SpellCheckingInspection
            this.ndef.onreadingerror = () => {
                this.readEvent$.next({
                    readText: '',
                    error: this.privaLocalizationService.instant(readingTagErrorMessage),
                });
            };

            this.ndef.scan({ signal: this.abortController.signal }).then();
        } catch (error) {
            this.readerMalfunction$.next(true);
        }
    }

    stopReading(): void {
        this.abortController?.abort();
        this.abortController = undefined;
        this.ndef = undefined;
    }
}
